<template>
    <div class="flex items-end justify-start gap-4 px-4 text-sm">

        <div v-for="tab in tabs" :key="tab"
            class="pb-3 pt-2 mt-5 border-b-2 hover:text-blue-500 hover:border-blue-500 transition cursor-pointer font-bold"
            @click="$emit('update', tab)"
            :class="active === tab ? 'text-blue-500 border-blue-500' : 'text-gray-400 border-blue-500/0'">
            {{ tab }}
        </div>
        <div class="flex-grow"></div>
        <div class="justify-self-end">
            <slot></slot>
        </div>
    </div>
</template>

<script>

export default {
    props: ["active", "tabs"],
    data() {
        return {
        };
    },
    emits: ["update"],
};

</script>